export const extractListFromValueInEnv = (valueInEnv: string | undefined): string[] => {
  return valueInEnv
    ? valueInEnv
        .split(",")
        .map((s) => s.trim().toLowerCase())
        .filter(Boolean)
    : [];
};

export const checkArrayIncludesValue = (array: string[] | undefined, value: string | undefined): boolean => {
  if (!array || !value) return false;
  return array.includes(value.toLowerCase());
};
